<template>
  <div style="display: flex" class="modal" v-show="value">
    <button @click.prevent="closeModal">X</button>
    <div class="modal-container">
      <div class="img-container"></div>
      <div class="text">
        <h1>
          Wisi forensibus.
        </h1>
        <p>
          Características:
          <br />
          {{description}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    description: {
      type: String,
      required: false,
      default: '',
    }
  },
  methods: {
    closeModal() {
      this.$emit("close", !this.value);
    },
  },
};
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #222ac3;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    position: absolute;
    top: 20px;
    right: 50px;
    width: 50px;
    height: 50px;
    background: transparent;
    border: 1px solid white;
    border-radius: 100%;
    color: white;
    cursor: pointer;
  }
  .modal-container{
    background-color: white;
    width: 1500px;
    height: 820px;
    display: flex;
    box-shadow: 0px 10px 20px #00003399;
    .img-container{
      background: url('../assets/img/modal.jpg');
      width: 535px;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    .text{
      width: 1105px;
      height: 100%;
      padding: 85px 155px 0 140px;
    }
  }
}
</style>
